import deleteAccount from './deleteAccount.js'
import getCampaign from './getCampaign.js'
import getCampaigns from './getCampaigns.js'
import getCampaignLive from './getCampaignLive.js'
import postLogin from './postLogin.js'
import getUser from './getUser.js'
import postUser from './postUser.js'
import postRegister from './postRegister.js'
import postResetRequest from './postResetRequest.js'
import postReset from './postReset.js'

export default {
  getCampaign,
  getCampaigns,
  getCampaignLive,
  postLogin,
  getUser,
  postUser,
  deleteAccount,
  postRegister,
  postResetRequest,
  postReset
}



// WEBPACK FOOTER //
// ./src/api/index.js